const AnalysisRoute = {
  path: "/analysis",
  component: () =>
    import("@/components/static_entity_analysis/containers/AnalysisParent"),
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: ":mode",
      component: () =>
        import("@/components/static_entity_analysis/containers/AnalysisStudio"),
      meta: {
        title: "Static Entity Analysis",
      },
    },
    // {
    //   path: "",
    //   redirect: "/",
    // },
  ],
};

export default AnalysisRoute;
